import React, { useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions'; 
import Loader from '../components/Loader';
import { useUser } from '../contexts/UserContext';
import { fetchData } from '../librairies/Firestore';
import Input from '../components/inputs/Input';
import FileInput from '../components/inputs/FileInput';
import { handleUpload } from '../librairies/FirebaseStorage';
import PrimaryButton from '../components/buttons/PrimaryButton';
import CheckboxInput from '../components/inputs/CheckboxInput';
import ShareButton from '../components/buttons/ShareButton';
import { TEXT_SHARE_COOWNERSHIP_CODE, TEXT_SHARE_COOWNERSHIP_CODE_PROVIDERS } from '../helpers/Text';
import { rentalManagerCanMakeActionOnCoownership } from '../librairies/UsersLib';
import { isRentalManager } from '../contexts/UserContext';
import AppDisplayPreview from '../components/AppDisplayPreview';
import residencePreview from '../assets/images/app-display/residence.jpeg';

const db = getFirestore(app);
const functions = getFunctions(app, 'europe-west3');

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const rentalManagerEmailsFromCoownership = (coownership) => {
  const stored = Array.isArray(coownership?.rentalManagerEmails) ? coownership.rentalManagerEmails : [];
  return [0, 1, 2].map((index) => String(stored[index] ?? ""));
};

const rentalManagerEmailsToStore = (emails) =>
  [0, 1, 2].map((index) => String(emails[index] || "").trim());

const collectRentalManagerEmailErrors = (emails) => {
  const emailErrors = {};
  rentalManagerEmailsToStore(emails).forEach((email, index) => {
    if (email && !EMAIL_REGEX.test(email)) {
      emailErrors[`rentalManagerEmail${index + 1}`] = "Format d'email invalide";
    }
  });
  return emailErrors;
};

const ManageCoownership = () => {

  const [coownership, setCoownership] = useState(null); 
  const [loader, setLoader] = useState(true);
  const [loaderModify, setLoaderModify] = useState(false);

  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [syndicPhone, setSyndicPhone] = useState("");
  const [syndicEmail, setSyndicEmail] = useState("");
  const [syndicEmail2, setSyndicEmail2] = useState("");
  const [rentalManagerEmails, setRentalManagerEmails] = useState(["", "", ""]);
  const [mailSyndicVisible, setMailSyndicVisible] = useState(false);
  const [syndicName, setSyndicName] = useState("");
  const [residenceName, setResidenceName] = useState("");
  const [image, setImage] = useState(null); 
  const [imageObject, setImageObject] = useState(null);
  //const [totalTantieme, setTotalTantieme] = useState(null); 
  const [links, setLinks] = useState([]); 
  const [chatActivatedOwner, setChatActivatedOwner] = useState(false); 
  const [chatActivatedTenant, setChatActivatedTenant] = useState(false); 
  const [chatActivatedCS, setChatActivatedCS] = useState(false); 

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [posterLoading, setPosterLoading] = useState(false);
  const [posterVisible, setPosterVisible] = useState(false);
  const [posterError, setPosterError] = useState("");

  const [errors, setErrors] = useState({
    address: '',
    city: '',
    postalCode: '',
    phone: '',
    email: '',
    email2: '',
    syndicName: '',
    residenceName: '',
    image: '',
  });

  //contexte de l'utilisateur connecté
  const user = useUser();



  useEffect(() => {
    //On récupère les infos de la copropriété 
    // eslint-disable-next-line 
    getCoownership();
  }, []); 

  /**
   * récupère les informations de la copropriété 
   */
  const getCoownership = async () => {
    
    const docRef = doc(db, user.user.userData.lastCoownershipLoaded.path);

    let data = await fetchData(docRef); 
    
    if(data !== null){
      setCoownership(data); 
      setLoader(false);
    }
  }

  const resetErrors = () => {
    setErrors({
      address: '',
      city: '',
      postalCode: '',
      phone: '',
      email: '',
      email2: '',
      syndicName: '',
      residenceName: '',
      image: '',
    }); 
  }

  /**
   * lorsqu'on a récupéré les infos de la copro, on update les states des champs du formulaire
   */
  useEffect(() => {
    if(coownership !== null){
      console.log(coownership)
      setAddress(coownership.address);
      setResidenceName(coownership.name);
      setZip(coownership.zip);
      setCity(coownership.city);
      setSyndicPhone(coownership.phoneSyndic ?? "");
      setSyndicEmail(coownership.mailSyndic ?? ""); 
      setSyndicEmail2(coownership.mailSyndic2 ?? "");
      setRentalManagerEmails(rentalManagerEmailsFromCoownership(coownership));
      setSyndicName(coownership.nameSyndic ?? "");
      setImage(coownership.image);
      setMailSyndicVisible(coownership.mailSyndicVisible);
      //setTotalTantieme((coownership.totalTantieme !== undefined && coownership.totalTantieme !== null ) ? coownership.totalTantieme : "");
      setChatActivatedOwner(coownership.chatActivatedOwner);
      setChatActivatedTenant(coownership.chatActivatedTenant);
      setChatActivatedCS(coownership.chatActivatedCS);

      if(coownership.links !== undefined && coownership.links !== null)
        setLinks(coownership.links)
    }

  }, [coownership]); 


  const handleRentalManagerEmailChange = (index, value) => {
    setRentalManagerEmails((current) => {
      const next = [...current];
      next[index] = value;
      return next;
    });
  };

  const saveRentalManagerEmailsOnly = async () => {
    const emailErrors = collectRentalManagerEmailErrors(rentalManagerEmails);
    setErrors((current) => ({
      ...current,
      rentalManagerEmail1: emailErrors.rentalManagerEmail1 || "",
      rentalManagerEmail2: emailErrors.rentalManagerEmail2 || "",
      rentalManagerEmail3: emailErrors.rentalManagerEmail3 || "",
    }));

    if (Object.keys(emailErrors).length > 0) {
      setSuccess("");
      setError("");
      return;
    }

    try {
      setLoaderModify(true);
      const coownershipRef = doc(db, user.user.userData.lastCoownershipLoaded.path);
      await updateDoc(coownershipRef, {
        rentalManagerEmails: rentalManagerEmailsToStore(rentalManagerEmails),
      });
      setLoaderModify(false);
      setSuccess("Les e-mails ont bien été enregistrés");
      setError("");
      resetErrors();
    } catch (err) {
      console.log(err);
      setError("Une erreur est survenue, impossible d'enregistrer les e-mails");
      setSuccess("");
      setLoaderModify(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rentalManagerCanMakeActionOnCoownership(user.user)) {
      await saveRentalManagerEmailsOnly();
      return;
    }

    // Validation des champs
    const newErrors = {};

    if (!address) {
      newErrors.address = "L'adresse est requise.";
    }

    if (!city) {
      newErrors.city = "La ville est requise.";
    }

    if (!zip) {
      newErrors.postalCode = "Le code postal est requis.";
    }

    if (!residenceName) {
      newErrors.residenceName = "Le nom de la résidence est requis.";
    }

    if (isRentalManager(user.user)) {
      Object.assign(newErrors, collectRentalManagerEmailErrors(rentalManagerEmails));
    }

    if (Object.keys(newErrors).length === 0) {
      console.log("Données du formulaire valides.");

      try{
        setLoaderModify(true);
        
        //on envoie les données sur firestore 
        const coownershipRef = doc(db, user.user.userData.lastCoownershipLoaded.path);
    
        const coownershipUpdate = {
          address: address,
          city: city,
          zip: zip,
          mailSyndic: syndicEmail,
          mailSyndic2: syndicEmail2,
          name: residenceName,
          nameSyndic: syndicName,
          phoneSyndic: syndicPhone,
          mailSyndicVisible: (mailSyndicVisible !== undefined ? mailSyndicVisible : false), 
          chatActivatedOwner: (chatActivatedOwner !== undefined ? chatActivatedOwner : false),
          chatActivatedTenant: (chatActivatedTenant !== undefined ? chatActivatedTenant : false),
          chatActivatedCS: (chatActivatedCS !== undefined ? chatActivatedCS : false), 
          //totalTantieme: totalTantieme,
          links: links.length > 0 ? links : null
        };

        if (isRentalManager(user.user)) {
          coownershipUpdate.rentalManagerEmails = rentalManagerEmailsToStore(rentalManagerEmails);
        }

        await updateDoc(coownershipRef, coownershipUpdate);

        //l'image a été modifié 
        if(image !== coownership.image){
          
          try{
            let imageUrl = await handleUpload("coownershipPicture/", imageObject);
         
            console.log("image modifiée avec l'url : "+imageUrl);
            console.log(imageUrl);
  
            updateDoc(coownershipRef, {
              image: imageUrl
            });
          
          } catch (err){
            console.log(err);
          }
        }

        setLoaderModify(false);
        setSuccess("Les informations ont bien étées modifiées");
        setError("");
        resetErrors(); 
      } catch(err){
        console.log(err)
        setError("Une erreur est survenue, impossible de modifier les informations");
        resetErrors(); 
        setSuccess("");
        setLoaderModify(false);
      }
    } else {
      // Afficher les erreurs
      setErrors(newErrors);
      setSuccess("");
      setError("");
    }
  };




  const posterVariant = isRentalManager(user.user) ? "rental" : "syndic";
  const posterUrl = coownership?.poster?.[posterVariant]?.url || "";

  const generatePoster = async () => {
    if (posterLoading || posterUrl) return;

    setPosterLoading(true);
    setPosterError("");

    try {
      const coownershipId = user.user.userData.lastCoownershipLoaded.path.split("/")[1];
      const generatePromoPoster = httpsCallable(functions, "generatePromoPoster");
      const result = await generatePromoPoster({ coownershipId });
      const url = result.data?.url;

      if (!url) {
        setPosterError("Impossible de générer l'affiche.");
        return;
      }

      setCoownership((current) => ({
        ...current,
        poster: {
          ...(current?.poster || {}),
          [posterVariant]: {
            ...(current?.poster?.[posterVariant] || {}),
            url,
          },
        },
      }));
      setPosterVisible(true);
    } catch (err) {
      console.error(err);
      setPosterError(err?.message || "Impossible de générer l'affiche.");
    } finally {
      setPosterLoading(false);
    }
  };

  /**
   * Modification de l'image de la copropriété
   * @param {*} e 
   */
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log(file);
      // Vous pouvez effectuer des opérations supplémentaires ici, comme la validation du type de fichier
      setImage(URL.createObjectURL(file));
      setImageObject(file); 
    }
  };

  const handleLinkChange = (index, event) => {
    const { name, value } = event.target;
    const updatedFields = [...links];
    updatedFields[index][name] = value;
    setLinks(updatedFields);
  };

  const addLink = () => {
    setLinks([...links, { name: '', url: '' }]);
  };

  const removeLink = (index) => {
    const updatedFields = [...links];
    updatedFields.splice(index, 1);
    setLinks(updatedFields);
  };


  return (
    <div>
      <div className="flex justify-end">
        <AppDisplayPreview image={residencePreview} label="Aperçu de la résidence dans l'application" />
      </div>
      {loader ? (
        <Loader />
      ) : (
        <div className="mx-auto mt-4 p-4 bg-white rounded md:shadow">
          <h2 className="text-2xl text-center mb-4">Infos sur la résidence</h2>
          <form onSubmit={handleSubmit}>

            <div className='mb-6'>
              <p className='font-bold'>Codes</p>

              <div className='border-b border-gray mt-0.5 mb-2'></div>
                {isRentalManager(user.user) && rentalManagerCanMakeActionOnCoownership(user.user) ? (
                  <p>Transmettez respectivement ces codes aux locataires et prestataires de la copropriété.</p>
                ) : (
                  <p>Transmettez respectivement ces codes aux propriétaires, locataires et prestataires de la copropriété.</p>
                )}
              

              <div className='flex flex-wrap justify-center gap-2'>
                {isRentalManager(user.user) && rentalManagerCanMakeActionOnCoownership(user.user) ? (
                  <></>
                ) : (
                  <div className='bg-primary md:border-2 shadow-xl rounded-lg px-3 py-2 md:px-12 md:py-6'>
                    <p className='text-black text-center font-bold'>Code propriétaire</p>
                    <p className='text-center text-white text-md md:text-xl font-bold'>{coownership.codeOwner}</p>
                    {rentalManagerCanMakeActionOnCoownership(user.user) && (
                      <ShareButton text={TEXT_SHARE_COOWNERSHIP_CODE(coownership.codeOwner)} />
                    )}
                  </div>
                )}

                <div className='bg-primary md:border-2 shadow-xl rounded-lg px-3 py-2 md:px-12 md:py-6'>
                  <p className='text-black text-center font-bold'>Code locataire</p>
                  <p className='text-center text-white text-md md:text-xl font-bold'>{coownership.codeTenant}</p>
                  <ShareButton text={TEXT_SHARE_COOWNERSHIP_CODE(coownership.codeTenant)} />
                </div>

                <div className='bg-primary md:border-2 shadow-xl rounded-lg px-3 py-2 md:px-12 md:py-6'>
                  <p className='text-black text-center font-bold'>Code prestataire</p>
                  <p className='text-center text-white text-md md:text-xl font-bold'>{coownership.codeProvider}</p>
                  {rentalManagerCanMakeActionOnCoownership(user.user) && (
                    <ShareButton text={TEXT_SHARE_COOWNERSHIP_CODE_PROVIDERS(residenceName, coownership.codeProvider)} />
                  )}
                </div>
              </div>
            </div>

            <div className='mb-6'>
              <p className='font-bold'>Affiche</p>
              <div className='border-b border-gray mt-0.5 mb-2'></div>
              <p className='mb-3'>Affiche à imprimer pour la résidence, avec le code locataire.</p>
              <div className='text-center'>
                {posterUrl ? (
                  <PrimaryButton type={"button"} value={"Afficher l'image"} onClick={() => setPosterVisible(true)} />
                ) : (
                  <PrimaryButton type={"button"} value={"Générer l'affiche"} onClick={generatePoster} loading={posterLoading} disabled={posterLoading} />
                )}
              </div>
              {posterError !== "" ? (
                <p className='justify-center flex my-1 text-red-500'>{posterError}</p>
              ) : null}
              {posterVisible && posterUrl ? (
                <div className='mt-4 text-center'>
                  <img src={posterUrl} alt="Affiche de la résidence" className="mx-auto w-full max-w-md border border-gray-200" />
                  <a href={posterUrl} target="_blank" rel="noopener noreferrer" className="inline-block mt-3 text-primary underline">Télécharger l'image</a>
                </div>
              ) : null}
            </div>

            <div className='mb-6'>
              <p className='font-bold'>Copropriété</p>

              <div className='border-b border-gray mt-0.5 mb-2'></div>

              <FileInput id={"image"} label={"Image"} name={"image"} file={image} onChange={handleImageChange} error={errors.image} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <Input id={"residenceName"} label={"Nom de la résidence"} type={"text"} name={"residenceName"} value={residenceName} onChange={(event) => setResidenceName(event.target.value)} error={errors.residenceName} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <Input id={"address"} label={"Adresse"} type={"text"} name={"address"} value={address} onChange={(event) => setAddress(event.target.value)} error={errors.address} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <Input id={"zip"} label={"Code Postal"} type={"text"} name={"zip"} value={zip} onChange={(event) => setZip(event.target.value)} error={errors.zip} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <Input id={"city"} label={"Ville"} type={"text"} name={"city"} value={city} onChange={(event) => setCity(event.target.value)} error={errors.city} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
            </div>

            <div className='mb-6'>
              <p className='font-bold'>Gestionnaire</p>

              <div className='border-b border-gray mt-0.5 mb-2'></div>

              <Input id={"syndicName"} label={"Nom du gestionnaire"} type={"text"} name={"syndicName"} value={syndicName} onChange={(event) => setSyndicName(event.target.value)} error={errors.syndicName} required={false} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <Input id={"syndicEmail"} label={"e-mail du gestionnaire"} type={"email"} name={"syndicEmail"} value={syndicEmail} onChange={(event) => setSyndicEmail(event.target.value)} error={errors.email} required={false} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <CheckboxInput id={"mailSyndicVisible"} label={"Visibilité de l'e-mail gestionnaire pour les copropriétaires et locataires"} name={"mailSyndicVisible"} checked={mailSyndicVisible} onChange={() => setMailSyndicVisible(!mailSyndicVisible)} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)}/>
              <Input id={"syndicEmail2"} label={"e-mail du gestionnaire (2ème adresse)"} type={"email"} name={"syndicEmail2"} value={syndicEmail2} onChange={(event) => setSyndicEmail2(event.target.value)} error={errors.email} required={false} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
              <Input id={"syndicPhone"} label={"Téléphone du gestionnaire"} type={"phone"} name={"syndicPhone"} value={syndicPhone} onChange={(event) => setSyndicPhone(event.target.value)} error={errors.phone} required={false} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)} />
            </div>

            {isRentalManager(user.user) && (
            <div className='mb-6'>
              <p className='font-bold'>E-mails gestionnaires locatifs</p>

              <div className='border-b border-gray mt-0.5 mb-2'></div>

              <p className='mb-3'>Ces adresses reçoivent les e-mails destinés au gestionnaire locatif. Trois adresses maximum.</p>

              <Input id={"rentalManagerEmail1"} label={"E-mail 1"} type={"email"} name={"rentalManagerEmail1"} value={rentalManagerEmails[0]} onChange={(event) => handleRentalManagerEmailChange(0, event.target.value)} error={errors.rentalManagerEmail1} required={false} />
              <Input id={"rentalManagerEmail2"} label={"E-mail 2"} type={"email"} name={"rentalManagerEmail2"} value={rentalManagerEmails[1]} onChange={(event) => handleRentalManagerEmailChange(1, event.target.value)} error={errors.rentalManagerEmail2} required={false} />
              <Input id={"rentalManagerEmail3"} label={"E-mail 3"} type={"email"} name={"rentalManagerEmail3"} value={rentalManagerEmails[2]} onChange={(event) => handleRentalManagerEmailChange(2, event.target.value)} error={errors.rentalManagerEmail3} required={false} />

              {isRentalManager(user.user) && !rentalManagerCanMakeActionOnCoownership(user.user) && (
                <div className="text-center mt-4">
                  <PrimaryButton type={"button"} value={"Enregistrer les e-mails"} onClick={saveRentalManagerEmailsOnly} loading={loaderModify} />
                </div>
              )}
            </div>
            )}

            <div className='mb-6'>
              <p className='font-bold'>Liens extranet (facultatif)</p>

              <div className='border-b border-gray mt-0.5 mb-2'></div>
              
              <p>Ajoutez des liens si vous souhaitez les rendre disponibles aux membres de la résidence. Ils apparaitront sur la fiche immeuble de l'application</p>

              <div className="container mx-auto p-4">
                {links !== undefined && links.length > 0 ? (
                  links.map((field, index) => (
                    <div key={index} className="mb-4 md:flex items-center">
                      <input
                        type="text"
                        name="name"
                        value={field.name}
                        placeholder="Nom"
                        onChange={(e) => handleLinkChange(index, e)}
                        className="w-48 p-2 border border-gray-400 rounded-lg mb-2"
                        disabled={!rentalManagerCanMakeActionOnCoownership(user.user)}
                      />
                      <input
                        type="link"
                        name="url"
                        value={field.url}
                        placeholder="Lien"
                        onChange={(e) => handleLinkChange(index, e)}
                        className="w-48 p-2 border border-gray-400 rounded-lg md:ml-4 mb-2"
                        disabled={!rentalManagerCanMakeActionOnCoownership(user.user)}
                      />
                      <button
                        type="button"
                        onClick={() => removeLink(index)}
                        className="bg-red-500 text-white p-2 rounded-lg md:ml-4 mb-2"
                      >
                        Supprimer le lien
                      </button>
                    </div>
                  ))
                ) : null }

                {rentalManagerCanMakeActionOnCoownership(user.user) && (
                  <button
                    type="button"
                    onClick={addLink}
                    className="bg-secondary text-white p-2 rounded-lg"
                  >
                    + Ajouter un lien
                  </button>
                )}
              </div>
            </div>


            <div className='mb-6'>
              <p className='font-bold'>Chat Messagerie</p>

              <div className='border-b border-gray mt-0.5 mb-2'></div>


              {isRentalManager(user.user) && rentalManagerCanMakeActionOnCoownership(user.user) ? (
                <></>
              ) : (
                <CheckboxInput id={"chatActivateOwner"} label={"Activation du chat copropriétaires"} name={"chatActivatedOwner"} checked={chatActivatedOwner} onChange={() => setChatActivatedOwner(!chatActivatedOwner)} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)}/>
              )}

              <CheckboxInput id={"chatActivatedTenant"} label={"Activation du chat locataires"} name={"chatActivatedTenant"} checked={chatActivatedTenant} onChange={() => setChatActivatedTenant(!chatActivatedTenant)} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)}/>
              
              {isRentalManager(user.user) && rentalManagerCanMakeActionOnCoownership(user.user) ? (
                <></>
              ) : (
              <CheckboxInput id={"chatActivatedCS"} label={"Activation du chat conseil syndical"} name={"chatActivatedCS"} checked={chatActivatedCS} onChange={() => setChatActivatedCS(!chatActivatedCS)} disabled={!rentalManagerCanMakeActionOnCoownership(user.user)}/>
              )}
            </div>
            
            {rentalManagerCanMakeActionOnCoownership(user.user) && (
              <div className="text-center">
                <PrimaryButton type={"submit"} value={"Modifier"} loading={loaderModify} />
              </div>
            )}

            {success !== "" ? (
              <p className='justify-center flex my-1 text-green-500'>{success}</p>
            ) : null}

            {error !== "" ? (
              <p className='justify-center flex my-1 text-red-500'>{error}</p>
            ) : null}
          </form>
        </div>
      )}

    </div>

  );
};

export default ManageCoownership;
